import React from 'react';
import { IconProps } from '.';

const SvgFolder = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M10 3.25h.401l.223.334 1.777 2.666H22.75v14.5H1.25V3.25H10Zm.599 3-1-1.5H2.75v1.5h7.849ZM2.75 7.75v11.5h18.5V7.75H2.75Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgFolder;
